/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as PassportRouteImport } from './routes/passport'
import { Route as MapRouteImport } from './routes/map'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as DealsRouteImport } from './routes/deals'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AiSearchRouteImport } from './routes/ai-search'
import { Route as AiRouteImport } from './routes/ai'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnitIdRouteImport } from './routes/unit.$id'
import { Route as PropertyIdRouteImport } from './routes/property.$id'
import { Route as LockNewRouteImport } from './routes/lock.new'
import { Route as LockCodeRouteImport } from './routes/lock.$code'
import { Route as AdminCatalogsRouteImport } from './routes/admin.catalogs'
import { Route as OnboardingUnitUnitIdFloorPlanRouteImport } from './routes/onboarding.unit.$unitId.floor-plan'
import { Route as CountryCityDeveloperComplexUnitUnitRouteImport } from './routes/$country.$city.$developer.$complex.unit.$unit'
import { Route as CountryRegionCityDistrictDeveloperComplexTypeUnitRouteImport } from './routes/$country.$region.$city.$district.$developer.$complex.$type.$unit'

const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const PassportRoute = PassportRouteImport.update({
  id: '/passport',
  path: '/passport',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedRoute = FeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesRoute = FavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsRoute = DealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareRoute = CompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const AiSearchRoute = AiSearchRouteImport.update({
  id: '/ai-search',
  path: '/ai-search',
  getParentRoute: () => rootRouteImport,
} as any)
const AiRoute = AiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnitIdRoute = UnitIdRouteImport.update({
  id: '/unit/$id',
  path: '/unit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertyIdRoute = PropertyIdRouteImport.update({
  id: '/property/$id',
  path: '/property/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LockNewRoute = LockNewRouteImport.update({
  id: '/lock/new',
  path: '/lock/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LockCodeRoute = LockCodeRouteImport.update({
  id: '/lock/$code',
  path: '/lock/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCatalogsRoute = AdminCatalogsRouteImport.update({
  id: '/admin/catalogs',
  path: '/admin/catalogs',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingUnitUnitIdFloorPlanRoute =
  OnboardingUnitUnitIdFloorPlanRouteImport.update({
    id: '/onboarding/unit/$unitId/floor-plan',
    path: '/onboarding/unit/$unitId/floor-plan',
    getParentRoute: () => rootRouteImport,
  } as any)
const CountryCityDeveloperComplexUnitUnitRoute =
  CountryCityDeveloperComplexUnitUnitRouteImport.update({
    id: '/$country/$city/$developer/$complex/unit/$unit',
    path: '/$country/$city/$developer/$complex/unit/$unit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CountryRegionCityDistrictDeveloperComplexTypeUnitRoute =
  CountryRegionCityDistrictDeveloperComplexTypeUnitRouteImport.update({
    id: '/$country/$region/$city/$district/$developer/$complex/$type/$unit',
    path: '/$country/$region/$city/$district/$developer/$complex/$type/$unit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/ai-search': typeof AiSearchRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/compare': typeof CompareRoute
  '/deals': typeof DealsRoute
  '/favorites': typeof FavoritesRoute
  '/feed': typeof FeedRoute
  '/map': typeof MapRoute
  '/passport': typeof PassportRoute
  '/search': typeof SearchRoute
  '/admin/catalogs': typeof AdminCatalogsRoute
  '/lock/$code': typeof LockCodeRoute
  '/lock/new': typeof LockNewRoute
  '/property/$id': typeof PropertyIdRoute
  '/unit/$id': typeof UnitIdRoute
  '/onboarding/unit/$unitId/floor-plan': typeof OnboardingUnitUnitIdFloorPlanRoute
  '/$country/$city/$developer/$complex/unit/$unit': typeof CountryCityDeveloperComplexUnitUnitRoute
  '/$country/$region/$city/$district/$developer/$complex/$type/$unit': typeof CountryRegionCityDistrictDeveloperComplexTypeUnitRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/ai-search': typeof AiSearchRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/compare': typeof CompareRoute
  '/deals': typeof DealsRoute
  '/favorites': typeof FavoritesRoute
  '/feed': typeof FeedRoute
  '/map': typeof MapRoute
  '/passport': typeof PassportRoute
  '/search': typeof SearchRoute
  '/admin/catalogs': typeof AdminCatalogsRoute
  '/lock/$code': typeof LockCodeRoute
  '/lock/new': typeof LockNewRoute
  '/property/$id': typeof PropertyIdRoute
  '/unit/$id': typeof UnitIdRoute
  '/onboarding/unit/$unitId/floor-plan': typeof OnboardingUnitUnitIdFloorPlanRoute
  '/$country/$city/$developer/$complex/unit/$unit': typeof CountryCityDeveloperComplexUnitUnitRoute
  '/$country/$region/$city/$district/$developer/$complex/$type/$unit': typeof CountryRegionCityDistrictDeveloperComplexTypeUnitRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/ai-search': typeof AiSearchRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/compare': typeof CompareRoute
  '/deals': typeof DealsRoute
  '/favorites': typeof FavoritesRoute
  '/feed': typeof FeedRoute
  '/map': typeof MapRoute
  '/passport': typeof PassportRoute
  '/search': typeof SearchRoute
  '/admin/catalogs': typeof AdminCatalogsRoute
  '/lock/$code': typeof LockCodeRoute
  '/lock/new': typeof LockNewRoute
  '/property/$id': typeof PropertyIdRoute
  '/unit/$id': typeof UnitIdRoute
  '/onboarding/unit/$unitId/floor-plan': typeof OnboardingUnitUnitIdFloorPlanRoute
  '/$country/$city/$developer/$complex/unit/$unit': typeof CountryCityDeveloperComplexUnitUnitRoute
  '/$country/$region/$city/$district/$developer/$complex/$type/$unit': typeof CountryRegionCityDistrictDeveloperComplexTypeUnitRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai'
    | '/ai-search'
    | '/cart'
    | '/checkout'
    | '/compare'
    | '/deals'
    | '/favorites'
    | '/feed'
    | '/map'
    | '/passport'
    | '/search'
    | '/admin/catalogs'
    | '/lock/$code'
    | '/lock/new'
    | '/property/$id'
    | '/unit/$id'
    | '/onboarding/unit/$unitId/floor-plan'
    | '/$country/$city/$developer/$complex/unit/$unit'
    | '/$country/$region/$city/$district/$developer/$complex/$type/$unit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai'
    | '/ai-search'
    | '/cart'
    | '/checkout'
    | '/compare'
    | '/deals'
    | '/favorites'
    | '/feed'
    | '/map'
    | '/passport'
    | '/search'
    | '/admin/catalogs'
    | '/lock/$code'
    | '/lock/new'
    | '/property/$id'
    | '/unit/$id'
    | '/onboarding/unit/$unitId/floor-plan'
    | '/$country/$city/$developer/$complex/unit/$unit'
    | '/$country/$region/$city/$district/$developer/$complex/$type/$unit'
  id:
    | '__root__'
    | '/'
    | '/ai'
    | '/ai-search'
    | '/cart'
    | '/checkout'
    | '/compare'
    | '/deals'
    | '/favorites'
    | '/feed'
    | '/map'
    | '/passport'
    | '/search'
    | '/admin/catalogs'
    | '/lock/$code'
    | '/lock/new'
    | '/property/$id'
    | '/unit/$id'
    | '/onboarding/unit/$unitId/floor-plan'
    | '/$country/$city/$developer/$complex/unit/$unit'
    | '/$country/$region/$city/$district/$developer/$complex/$type/$unit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiRoute: typeof AiRoute
  AiSearchRoute: typeof AiSearchRoute
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  CompareRoute: typeof CompareRoute
  DealsRoute: typeof DealsRoute
  FavoritesRoute: typeof FavoritesRoute
  FeedRoute: typeof FeedRoute
  MapRoute: typeof MapRoute
  PassportRoute: typeof PassportRoute
  SearchRoute: typeof SearchRoute
  AdminCatalogsRoute: typeof AdminCatalogsRoute
  LockCodeRoute: typeof LockCodeRoute
  LockNewRoute: typeof LockNewRoute
  PropertyIdRoute: typeof PropertyIdRoute
  UnitIdRoute: typeof UnitIdRoute
  OnboardingUnitUnitIdFloorPlanRoute: typeof OnboardingUnitUnitIdFloorPlanRoute
  CountryCityDeveloperComplexUnitUnitRoute: typeof CountryCityDeveloperComplexUnitUnitRoute
  CountryRegionCityDistrictDeveloperComplexTypeUnitRoute: typeof CountryRegionCityDistrictDeveloperComplexTypeUnitRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passport': {
      id: '/passport'
      path: '/passport'
      fullPath: '/passport'
      preLoaderRoute: typeof PassportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals': {
      id: '/deals'
      path: '/deals'
      fullPath: '/deals'
      preLoaderRoute: typeof DealsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare': {
      id: '/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-search': {
      id: '/ai-search'
      path: '/ai-search'
      fullPath: '/ai-search'
      preLoaderRoute: typeof AiSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai': {
      id: '/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unit/$id': {
      id: '/unit/$id'
      path: '/unit/$id'
      fullPath: '/unit/$id'
      preLoaderRoute: typeof UnitIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/property/$id': {
      id: '/property/$id'
      path: '/property/$id'
      fullPath: '/property/$id'
      preLoaderRoute: typeof PropertyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lock/new': {
      id: '/lock/new'
      path: '/lock/new'
      fullPath: '/lock/new'
      preLoaderRoute: typeof LockNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lock/$code': {
      id: '/lock/$code'
      path: '/lock/$code'
      fullPath: '/lock/$code'
      preLoaderRoute: typeof LockCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/catalogs': {
      id: '/admin/catalogs'
      path: '/admin/catalogs'
      fullPath: '/admin/catalogs'
      preLoaderRoute: typeof AdminCatalogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/unit/$unitId/floor-plan': {
      id: '/onboarding/unit/$unitId/floor-plan'
      path: '/onboarding/unit/$unitId/floor-plan'
      fullPath: '/onboarding/unit/$unitId/floor-plan'
      preLoaderRoute: typeof OnboardingUnitUnitIdFloorPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$country/$city/$developer/$complex/unit/$unit': {
      id: '/$country/$city/$developer/$complex/unit/$unit'
      path: '/$country/$city/$developer/$complex/unit/$unit'
      fullPath: '/$country/$city/$developer/$complex/unit/$unit'
      preLoaderRoute: typeof CountryCityDeveloperComplexUnitUnitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$country/$region/$city/$district/$developer/$complex/$type/$unit': {
      id: '/$country/$region/$city/$district/$developer/$complex/$type/$unit'
      path: '/$country/$region/$city/$district/$developer/$complex/$type/$unit'
      fullPath: '/$country/$region/$city/$district/$developer/$complex/$type/$unit'
      preLoaderRoute: typeof CountryRegionCityDistrictDeveloperComplexTypeUnitRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiRoute: AiRoute,
  AiSearchRoute: AiSearchRoute,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  CompareRoute: CompareRoute,
  DealsRoute: DealsRoute,
  FavoritesRoute: FavoritesRoute,
  FeedRoute: FeedRoute,
  MapRoute: MapRoute,
  PassportRoute: PassportRoute,
  SearchRoute: SearchRoute,
  AdminCatalogsRoute: AdminCatalogsRoute,
  LockCodeRoute: LockCodeRoute,
  LockNewRoute: LockNewRoute,
  PropertyIdRoute: PropertyIdRoute,
  UnitIdRoute: UnitIdRoute,
  OnboardingUnitUnitIdFloorPlanRoute: OnboardingUnitUnitIdFloorPlanRoute,
  CountryCityDeveloperComplexUnitUnitRoute:
    CountryCityDeveloperComplexUnitUnitRoute,
  CountryRegionCityDistrictDeveloperComplexTypeUnitRoute:
    CountryRegionCityDistrictDeveloperComplexTypeUnitRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
